import { r2Fetch } from './client';

export interface R2FileTransferParams {
  from_bucket_id: string;
  to_bucket_id: string;
  key: string;
  if_match?: string;
}

export interface R2FileTransferResponse {
  key: string;
  etag: string;
  size: number;
  uploaded: string;
  metadata: Record<string, string>;
}

export async function r2FileTransfer(
  params: R2FileTransferParams
): Promise<R2FileTransferResponse> {
  return r2Fetch<R2FileTransferResponse>('/rpc/r2_file_transfer', {
    body: params,
  });
}
